import { jsx as _jsx } from "react/jsx-runtime";
import { ChakraProvider } from '@chakra-ui/react';
import Compose from 'react-compose-components';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './config/localization';
import { AxiosInterceptor } from './services/instance';
import { AuthProvider, ConfigProvider, QuestionnaireProvider, UIProvider } from './store';
import theme from './styles/theme';
// Log the app version to the console for convenience
console.info(`App version: ${process.env.VERSION}`);
const container = document.getElementById('app');
const root = createRoot(container);
root.render(_jsx(Compose, Object.assign({ components: [
        BrowserRouter,
        [ChakraProvider, { resetCSS: true, theme }],
        UIProvider,
        QuestionnaireProvider,
        ConfigProvider,
        AuthProvider,
        AxiosInterceptor
    ] }, { children: _jsx(App, {}) })));
